import { RQAPICallWithData } from 'store/APIClient';
import { ALL_BUDGETS_VALUE } from 'routes/BudgetModule/components/BudgetOverview/constants';
import { useGetBudgetUserExerciceSettings } from 'routes/BudgetModule/components/shared/BudgetReportToggle/hooks';
import { createBudgetQueryKeys } from 'routes/BudgetModule/helpers/createBudgetQueryKeys';
import { useMultiYearsComparisonQuery } from 'routes/BudgetModule/helpers/hooks/useCustomQuery';

export type MultiYearsComparisonResponseDataT = {
    budgetName: string;
    produitsFonctionnement: number;
    epargneBrute: number;
    epargneGestion: number;
    epargneNette: number;
    year: number;
    yearN: number;
    amountType?: string;
};

type MultiYearsComparisonResponseColumnT = {
    key: string;
    type: DataTypesT;
};

type MultiYearsComparisonPayloadT = {
    column: MultiYearsComparisonResponseColumnT[];
    data: MultiYearsComparisonResponseDataT[];
};

type MultiYearsComparisonResponseT = {
    data: MultiYearsComparisonPayloadT;
};

const createMultiYearsComparisonEndpoint = (
    year: number,
    budgetName?: string | null,
): string => {
    let endpoint = `budget_proposals/${year}`;

    if (budgetName && budgetName !== ALL_BUDGETS_VALUE) {
        endpoint += `/${budgetName}`;
    }

    endpoint += '/get_multi_year_comparison';
    return endpoint;
};

export const useGetMultiYearsComparison = (
    year: number,
    budgetName: string | null | undefined,
): {
    data: MultiYearsComparisonPayloadT | undefined;
    isLoading: boolean;
} => {
    const { budgetReportExerciceData } = useGetBudgetUserExerciceSettings(year);
    const { multiYearsComparisonKeys } = createBudgetQueryKeys();
    return useMultiYearsComparisonQuery(
        multiYearsComparisonKeys({
            year,
            budgetName,
            isReportedAmountUsed:
                budgetReportExerciceData?.isReportedAmountUsed,
        }),
        async () => {
            const response =
                await RQAPICallWithData<MultiYearsComparisonResponseT>({
                    endpoint: createMultiYearsComparisonEndpoint(
                        year,
                        budgetName,
                    ),
                    method: 'GET',
                });

            return response.content.data;
        },
    );
};
